import { currentLocaleTag } from '../../../lib/formatting'
import { formatCents } from '../../../lib/money'

// ============================================================================
// Formato de ratios
// ============================================================================

export type RatioFormat = 'ratio' | 'pct' | 'cents'

export function formatRatio(value: number | null, format: RatioFormat): string {
  if (value === null) return 'N/A'
  const locale = currentLocaleTag()
  switch (format) {
    case 'ratio':
      return new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value)
    case 'pct':
      return `${new Intl.NumberFormat(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(value)} %`
    case 'cents':
      return formatCents(value)
  }
}
